/* eslint-disable */
/* eslint-disable @typescript-eslint/rule-name */
export default async function checkAvailableApp(credUrl) {
  if (window.PaymentRequest) {
    var supportedInstrumentsgpay = [
      {
        supportedMethods: ['https://tez.google.com/pay'],
        data: { url: 'https://www.gokwik.co' },
      },
    ];
    var supportedInstrumentspp = [
      {
        supportedMethods: ['https://mercury.phonepe.com/transact/pay'],
        data: { url: 'https://www.gokwik.co' },
      },
    ];

    var supportedInstrumentsCredPay = [
      {
        supportedMethods: [credUrl],
        data: { url: 'https://www.gokwik.co' },
      },
    ];

    var details = {
      total: {
        label: 'Total',
        amount: {
          currency: 'INR',
          value: 0,
        },
      },
    };
    const options = {};
    let requestgpay = null;
    let requestpp = null;
    let credpay = null;
    try {
      requestgpay = await checkCanMakePayment(supportedInstrumentsgpay, details, options);
      requestpp = await checkCanMakePayment(supportedInstrumentspp, details, options);
      credpay = await checkCanMakePayment(supportedInstrumentsCredPay, details, options);
      return [requestgpay, requestpp, credpay];
    } catch (e) {
      return [false, false, false];
    }
  }
}

async function checkCanMakePayment(payload, details, options) {
  return await new PaymentRequest(payload, details, options).canMakePayment().then((res) => res);
}
